import { groupsApi as api } from './groupsApi';
export const addTagTypes = ['user'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      userGroupsCreate: build.mutation<
        UserGroupsCreateApiResponse,
        UserGroupsCreateApiArg
      >({
        query: queryArg => ({
          url: `/user/groups/`,
          method: 'POST',
          body: queryArg.group
        }),
        invalidatesTags: ['user']
      }),
      userGroupsRead: build.query<
        UserGroupsReadApiResponse,
        UserGroupsReadApiArg
      >({
        query: queryArg => ({ url: `/user/groups/${queryArg.uuid}/` }),
        providesTags: ['user']
      }),
      userGroupsPartialUpdate: build.mutation<
        UserGroupsPartialUpdateApiResponse,
        UserGroupsPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/user/groups/${queryArg.uuid}/`,
          method: 'PATCH',
          body: queryArg.group
        }),
        invalidatesTags: ['user']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type UserGroupsCreateApiResponse = /** status 200 Custom Response */ {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: GroupRead[];
  ok?: boolean;
  message?: {
    text?: string | null;
    code?: number;
    args?: object | null;
  };
};
export type UserGroupsCreateApiArg = {
  group: Group;
};
export type UserGroupsReadApiResponse = /** status 200 Custom Response */ {
  results: GroupRead;
  ok?: boolean;
  message?: {
    text?: string | null;
    code?: number;
    args?: object | null;
  };
};
export type UserGroupsReadApiArg = {
  uuid: string;
};
export type UserGroupsPartialUpdateApiResponse =
  /** status 200 Custom Response */ {
    results: GroupRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserGroupsPartialUpdateApiArg = {
  uuid: string;
  group: Group;
};
export type Group = {
  name: string;
  parent?: string | null;
  permissions?: number[];
};
export type GroupRead = {
  id?: number;
  uuid?: string;
  name: string;
  parent?: string | null;
  permissions?: number[];
};
export const {
  useUserGroupsCreateMutation,
  useUserGroupsReadQuery,
  useUserGroupsPartialUpdateMutation
} = injectedRtkApi;
